import React from 'react';
import {
    Card,
    ExamStatus,
    ExamTable,
    ExamType,
    MappedExamApplicationStatuses,
} from 'components';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { ExamApplicationStatus, IApplicantExam, MyExamStatus } from '../../api/ApiClient';
import { Color, ColorStatus } from '_helpers';
import { useLocalErrorHandler } from 'hooks';
import query from '../../helpers/const/query';

const ApplicantExamsContainer = ({
    onPush, fetchMyExamApplications, examsList, apiError, setErrorHandler,
}: Props) => {
    const [filter, setFilter] = React.useState(MyExamStatus.All);
    const [processing, setProcessing] = React.useState(false);

    useLocalErrorHandler(setErrorHandler);

    React.useEffect(() => {
        const fetch = async () => {
            setProcessing(true);
            await fetchMyExamApplications({ myExamStatus: MyExamStatus.All, sortField: 'date', sortOrder: false });
            setProcessing(false);
        };

        fetch();
    }, [filter]);

    const HEADER = [
        'Дата и время',
        'Квалификация',
        'Тип',
        'СТАТУС',
    ];

    const getStatus = (exam: IApplicantExam) => {
        let status: ColorStatus;
        if (exam.processedByNark) {
            status = new ColorStatus(Color.Default, 'Утвержден');
            status.subStatus = exam.examApplicationStatus === ExamApplicationStatus.Passed ? new ColorStatus(Color.Success, 'Экзамен сдан') : new ColorStatus(Color.Red, 'Экзамен не сдан');
        } else if (exam.examType === ExamType.Online && exam.examApplicationStatus === ExamApplicationStatus.Paid && !localStorage.getItem('readyForOnlineExam')) {
            status = new ColorStatus(Color.Orange, 'Пройти проверку системы');
        } else {
            status = statuses[exam.examApplicationStatus || exam.examStatus] || new ColorStatus(Color.Default, (exam.examApplicationStatus || exam.examStatus).toString());
        }
        return status;
    };

    const getExamData = (exam: IApplicantExam) => ({
        ...exam,
        status: getStatus(exam),
        id: exam.examId,
        name: exam.qualificationTitle,
    });

    const tableRows = examsList ? examsList.items.map(getExamData) : [];

    return (
        <Card
          title="Мои экзамены"
          category="Список всех ваших экзаменов"
          apiError={apiError}
          showLoader={processing}
          withoutPadding
        >
            {/* <div className={cn('d-flex mb-5', styles.filterBtnContainer)}>
                <CustomRadio
                  label="Все"
                  name="exam-filter"
                  option="all"
                  checked={filter === MyExamStatus.All}
                  onClick={() => setFilter(MyExamStatus.All)}
                  disabled={!!fetchProcessing}
                />
                <CustomRadio
                  label="Утвержден"
                  name="exam-filter"
                  className="ml-3"
                  option="processedByNark"
                  checked={filter === MyExamStatus.Approved}
                  onClick={() => setFilter(MyExamStatus.Approved)}
                  disabled={!!fetchProcessing}
                />
                <CustomRadio
                  label="Обработка"
                  name="exam-filter"
                  className="ml-3"
                  option="inReview"
                  checked={filter === MyExamStatus.Processing}
                  onClick={() => setFilter(MyExamStatus.Processing)}
                  disabled={!!fetchProcessing}
                />
                <CustomRadio
                  label="Вы записаны"
                  name="exam-filter"
                  className="ml-3"
                  option="paid"
                  checked={filter === MyExamStatus.Recorded}
                  onClick={() => setFilter(MyExamStatus.Recorded)}
                  disabled={!!fetchProcessing}
                />
                <CustomRadio
                  label="Отменен"
                  name="exam-filter"
                  className="ml-3"
                  option="canceled"
                  checked={filter === MyExamStatus.Canceled}
                  onClick={() => setFilter(MyExamStatus.Canceled)}
                  disabled={!!fetchProcessing}
                />
            </div> */}
            <ExamTable
              header={HEADER}
              tableRows={tableRows}
              onChooseExam={id => onPush(`/exam/${id}?from=${query.FROM.APPLICANT_EXAMS}`)}
              placeholderTitle="Экзамены отсутствуют"
              placeholderText="Здесь будут отображаться все Ваши экзамены"
            />
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    examsList: state.examApplications.myExamApplicationsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    fetchMyExamApplications: dispatch.examApplications.fetchMyExamApplicationsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
    onPush: (key: string) => dispatch(push(key)),
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type Props = connectedProps;

export default connect(mapState, mapDispatch)(ApplicantExamsContainer);

const statuses = {
    ...MappedExamApplicationStatuses,
    [ExamStatus.IsApplying as string]: new ColorStatus(Color.Success, 'Идет запись'),
    [ExamStatus.ApplyingFinished as string]: new ColorStatus(Color.Orange, 'Запись завершена'),
    [ExamApplicationStatus.PaymentRequired as string]: new ColorStatus(Color.Orange, 'Требуется оплата'),
    [ExamApplicationStatus.Paid as string]: new ColorStatus(Color.Default, 'Вы записаны'),
    [ExamApplicationStatus.Passed as string]: new ColorStatus(Color.Default, 'Обработка'),
    [ExamApplicationStatus.NotPassed as string]: new ColorStatus(Color.Default, 'Обработка'),
};
